export default __webpack_public_path__ + "static/media/Youtube.6be2e882.svg";